
import React, { useState, useEffect } from 'react'
import logo from "../assets/rxultimate.png"
import { IoMenu, IoClose } from "react-icons/io5";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showMenu && !e.target.closest('nav')) {
        setShowMenu(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showMenu]);

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 py-3'}`}>
      <div className="container mx-auto flex items-center justify-between px-5 lg:px-10">
        <div className="flex items-center">
          <img src={logo} alt="RX Ultimate Logo" className="h-10 md:h-12" />
        </div>
        
        {/* Desktop Navigation */}
        <ul className="hidden lg:flex items-center space-x-8">
          <li>
            <a href="#" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300 text-base">Home</a>
          </li>
          <li>
            <a href="#whyus" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300 text-base">About Us</a>
          </li>
          <li>
            <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300 text-base">Services</a>
          </li>
          <li>
            <a href="#join-us" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300 text-base">Contact Us</a>
          </li>
        </ul>
        
        {/* Login Button */}
        <div className="hidden lg:block">
          <a href="https://app.rxultimate.com">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
              Login
            </button>
          </a>
        </div>
        
        {/* Mobile Navigation Toggle */}
        <button 
          onClick={() => setShowMenu(!showMenu)} 
          className="lg:hidden text-gray-700 hover:text-blue-600 focus:outline-none"
          aria-label="Toggle menu"
        >
          {showMenu ? (
            <IoClose className="text-3xl" />
          ) : (
            <IoMenu className="text-3xl" />
          )}
        </button>
      </div>
      
      {/* Mobile Navigation Menu */}
      <div 
        className={`fixed top-0 right-0 h-full w-3/4 md:w-2/5 bg-white shadow-xl transform ${showMenu ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out lg:hidden overflow-y-auto z-50`}
      >
        <div className="px-6 py-8">
          <div className="flex justify-between items-center mb-8">
            <img src={logo} alt="RX Ultimate Logo" className="h-10" />
            <button 
              onClick={() => setShowMenu(false)}
              className="text-gray-500 hover:text-blue-600 focus:outline-none"
              aria-label="Close menu"
            >
              <IoClose className="text-2xl" />
            </button>
          </div>
          
          <ul className="space-y-6">
            <li>
              <a 
                href="#" 
                className="block text-gray-700 hover:text-blue-600 font-medium text-lg" 
                onClick={() => setShowMenu(false)}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="#whyus" 
                className="block text-gray-700 hover:text-blue-600 font-medium text-lg" 
                onClick={() => setShowMenu(false)}
              >
                About Us
              </a>
            </li>
            <li>
              <a 
                href="#services" 
                className="block text-gray-700 hover:text-blue-600 font-medium text-lg" 
                onClick={() => setShowMenu(false)}
              >
                Services
              </a>
            </li>
            <li>
              <a 
                href="#join-us" 
                className="block text-gray-700 hover:text-blue-600 font-medium text-lg" 
                onClick={() => setShowMenu(false)}
              >
                Contact Us
              </a>
            </li>
            <li className="pt-4">
              <a href="https://app.rxultimate.com" className="block">
                <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium shadow-md transition-colors duration-300">
                  Login
                </button>
              </a>
            </li>
          </ul>
        </div>
      </div>
      
      {/* Overlay when mobile menu is open */}
      {showMenu && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setShowMenu(false)}
        />
      )}
    </nav>
  )
}

export default Navbar